var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWutzzlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2086,
    height: 390,
    viewBox: "0 0 2086 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 949,
    y: 19,
    width: 343,
    height: 108,
    rx: 54,
    fill: "#45B4BB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1330,
    y: 19,
    width: 343,
    height: 108,
    rx: 54,
    fill: "#45B4BB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1718.86,
    y: 19,
    width: 343,
    height: 108,
    rx: 54,
    fill: "#45B4BB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1330,
    y: 254,
    width: 343,
    height: 108,
    rx: 54,
    fill: "#45B4BB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1718.86,
    y: 254,
    width: 343,
    height: 108,
    rx: 54,
    fill: "#45B4BB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.5,
    y: 19,
    width: 343,
    height: 108,
    rx: 54,
    transform: "rotate(90 1174.5 19)",
    fill: "#45B4BB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 99.164,
    y: 4.34006,
    width: 360,
    height: 108,
    rx: 54,
    transform: "rotate(66 99.164 4.34006)",
    fill: "#45B4BB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 108,
    rx: 54,
    transform: "matrix(-0.406737 0.913545 0.913545 0.406737 459.867 4.34005)",
    fill: "#567DE0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 311.164,
    y: 4.34005,
    width: 360,
    height: 108,
    rx: 54,
    transform: "rotate(66 311.164 4.34005)",
    fill: "#45B4BB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 108,
    rx: 54,
    transform: "matrix(-0.406737 0.913545 0.913545 0.406737 250.867 4.34005)",
    fill: "#567DE0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 442.325,
    height: 108,
    rx: 54,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 1383.51 389.139)",
    fill: "#567DE0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 442.325,
    height: 108,
    rx: 54,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 1772.37 389.139)",
    fill: "#567DE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M637 22.5C664.89 22.5 687.5 45.1096 687.5 73V169.469C687.5 214.388 697.885 234.53 705.973 243.347C713.3 251.336 725.622 257.5 749 257.5C776.89 257.5 799.5 280.11 799.5 308C799.5 335.89 776.89 358.5 749 358.5C707.728 358.5 664.05 347.062 631.54 311.617C599.789 277 586.5 227.877 586.5 169.469V73C586.5 45.1096 609.11 22.5 637 22.5Z",
    fill: "#567DE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M861 22.5C833.11 22.5 810.5 45.1096 810.5 73V169.469C810.5 214.388 800.115 234.53 792.027 243.347C784.7 251.336 772.378 257.5 749 257.5C721.11 257.5 698.5 280.11 698.5 308C698.5 335.89 721.11 358.5 749 358.5C790.272 358.5 833.95 347.062 866.46 311.617C898.211 277 911.5 227.877 911.5 169.469V73C911.5 45.1096 888.89 22.5 861 22.5Z",
    fill: "#567DE0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWutzzlogo);
export default __webpack_public_path__ + "static/media/wutzz logo.91ec34384fb70c1cb21e012b5630abb9.svg";
export { ForwardRef as ReactComponent };